import { render, staticRenderFns } from "./BodyMeasurementsForm.vue?vue&type=template&id=cbe2762c&scoped=true&"
import script from "./BodyMeasurementsForm.vue?vue&type=script&lang=js&"
export * from "./BodyMeasurementsForm.vue?vue&type=script&lang=js&"
import style0 from "./BodyMeasurementsForm.vue?vue&type=style&index=0&id=cbe2762c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe2762c",
  null
  
)

export default component.exports